export var ViewMode;
(function (ViewMode) {
  ViewMode["view"] = "view";
  ViewMode["edit"] = "edit";
  ViewMode["create"] = "create";
})(ViewMode || (ViewMode = {}));